var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbouticon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 68,
    height: 65,
    rx: 5,
    fill: "#022964"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 26.3333V36.3333L38.5 41.1666L39.8334 39.1666L33.1667 35.1666V26.3333H30.6667Z",
    fill: "#022964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8667 33C43.95 33.55 44 34.1 44 34.6666C44 41.1666 38.8333 46.3333 32.3333 46.3333C25.8333 46.3333 20.6667 41.1666 20.6667 34.6666C20.6667 28.1666 25.8333 23 32.3333 23C33.5 23 34.6167 23.1666 35.6667 23.4833V20.05C34.6 19.8 33.4833 19.6666 32.3333 19.6666C24 19.6666 17.3333 26.3333 17.3333 34.6666C17.3333 43 24 49.6666 32.3333 49.6666C40.6667 49.6666 47.3333 43 47.3333 34.6666C47.3333 34.1 47.3 33.55 47.2333 33H43.8667Z",
    fill: "#022964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 21.3333V16.3333H44V21.3333H39V24.6666H44V29.6666H47.3333V24.6666H52.3333V21.3333H47.3333Z",
    fill: "#022964"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbouticon2);
export default __webpack_public_path__ + "static/media/abouticon2.a1e35cdeab12fd7cc9b0a18abbc7b1ff.svg";
export { ForwardRef as ReactComponent };